module.exports = __webpack_public_path__ + "img/article-img.d246f0eb.png";